module.exports = __webpack_public_path__ + "img/simplecoin.178ec665.jpg";